// @flow

import SafeSuspense from 'app/packages/safe-suspense/SafeSuspense';

export default SafeSuspense;
